import { executeRequest, Request } from '@jfs/network'
import { getEncryptedPwdAndKey } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const getVerifyEmailBody = (emailId: string, otp: string) => {
  const encPwdNKey = getEncryptedPwdAndKey(otp)
  return {
    user: { mobile: { mobileNumber: '1234567890', countryCode: '91' }, emailAddress: emailId },
    scope: 'SESSION',
    authenticateList: [{ mode: '43', action: 'verify', value: encPwdNKey?.password ?? '' }],
    purpose: 2,
    secure: {
      encryptionKey: encPwdNKey?.key,
    },
  }
}

const verifyEmailOtp = (emailId: string, otp: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.userAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: getVerifyEmailBody(emailId, otp),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { verifyEmailOtp }
